import { createAction, props } from '@ngrx/store';

import ILiveSegmentsResults = Microsoft.VideoIndexer.Live.Contracts.ILiveSegmentsResults;

export const searchStarted = createAction(
  '[Live Segments/API] Search Started',
  props<{ query: string; text: string; filters: { [key: string]: string[] } }>()
);

export const clearSearch = createAction('[Live Segments] Clear Search');

export const searchSucceeded = createAction('[Live Segments/API] Search Succeeded', props<{ results: ILiveSegmentsResults }>());

export const searchFailed = createAction('[Live Segments/API] Search Failed', props<{ error: string }>());
